import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { compose } from '../../../../common/helpers'
import { connect } from 'react-redux'
import { Box, Row, Col } from '../..'
import { NumberField, SelectField, LensParamsField } from '../../fields'
import { appTypeConfig } from '../../../../common/config'

const { individualMenus } = appTypeConfig

const isFieldVisible = fieldConf => typeof fieldConf !== 'undefined'

const enhanceFields = (fields, menuConf) => {
  Object.keys(menuConf).forEach(key => {
    // console.log('key', key)
    const fieldConf = menuConf[key]
    const isRequired = typeof fieldConf === 'object' ? fieldConf.isRequired : fieldConf === true

    if (key === 'bvd') key = 'bvdR'
    const field = fields[key]
    if (field) {
      field.required = isRequired
      // console.log('field', field)
    }
  })
}

const IndividualSection = ({ fields, lensL, lensR, t }) => {
  if (
    !(
      (lensR && fields.lensR.value && lensR.individualMenu) ||
      (lensL && fields.lensL.value && lensL.individualMenu)
    )
  ) {
    return null
  }

  const menuConf = individualMenus[fields.individualMenu && fields.individualMenu.value]
  if (!menuConf) return null
  enhanceFields(fields, menuConf)
  // console.log('fields', fields)

  return (
    <Box>
      <Box.Header>
        <Box.Title>{t('individual data')}</Box.Title>
      </Box.Header>
      <Box.Content>
        <Row alignItems="flex-start">
          {isFieldVisible(menuConf.bvd) && (
            <Col width="33%">
              <NumberField
                label={t('back vertex distance')}
                {...fields.bvdR}
                onChange={e => {
                  fields.bvdL.onChange(e)
                  fields.bvdR.onChange(e)
                }}
                // required={fields.bvd.required}
                noMaxWidth
                errorsStyle={{ position: 'relative' }}
              />
            </Col>
          )}
          {isFieldVisible(menuConf.frameBowAngle) && (
            <Col width="33%">
              <NumberField
                // TODO - jak se bude jmenovat?
                // field máme frameBowAngle ale ve staré app je face form angle
                label={t('face form angle')}
                {...fields.frameBowAngle}
                // required={menuConf.frameBowAngle}
                noMaxWidth
                errorsStyle={{ position: 'relative' }}
              />
            </Col>
          )}
          {isFieldVisible(menuConf.panto) && (
            <Col width="33%">
              <NumberField
                label={t('pantoscopic tilt')}
                {...fields.panto}
                // required={menuConf.panto}
                noMaxWidth
                errorsStyle={{ position: 'relative' }}
              />
            </Col>
          )}
        </Row>
        {isFieldVisible(menuConf.proglen) && (
          <Row>
            <Col width="33%">
              <SelectField
                label={t('Progression length')}
                options={menuConf.proglen.options}
                {...fields.proglen}
              />
            </Col>
          </Row>
        )}
        <Row alignItems="flex-end">
          {isFieldVisible(menuConf.fvs) && (
            <Col width="25%">
              <NumberField
                label={t('Far vision sensitivity')}
                {...fields.fvs}
                noMaxWidth
                errorsStyle={{ position: 'relative' }}
              />
            </Col>
          )}
          {isFieldVisible(menuConf.nvs) && (
            <Col width="25%">
              <NumberField
                label={t('Near vision sensitivity')}
                {...fields.nvs}
                noMaxWidth
                errorsStyle={{ position: 'relative' }}
              />
            </Col>
          )}
          {isFieldVisible(menuConf.designType) && (
            <Col width="25%">
              <NumberField
                label={t('Design type')}
                {...fields.designType}
                noMaxWidth
                errorsStyle={{ position: 'relative' }}
              />
            </Col>
          )}
          {isFieldVisible(menuConf.contrastSv) && (
            <Col width="25%">
              <NumberField
                label={t('Contrast sensitivity')}
                {...fields.contrastSv}
                noMaxWidth
                errorsStyle={{ position: 'relative' }}
              />
            </Col>
          )}
        </Row>
        {isFieldVisible(menuConf.inset) && (
          <Row justifyContent="flex-start">
            <LensParamsField
              showSideLabels
              noBorder
              isDefaultOpen
              rightDisabled={!fields.rightLensEnabled.value}
              leftDisabled={!fields.leftLensEnabled.value}
              options={[
                {
                  label: t('inset'),
                  r: fields.insetR,
                  l: fields.insetL,
                },
              ]}
              style={{
                paddingLeft: '0',
                paddingTop: '0',
                marginLeft: '-14px',
                width: '100%',
              }}
            />
          </Row>
        )}
      </Box.Content>
    </Box>
  )
}

IndividualSection.defaultProps = {
  lensR: {},
  lensL: {},
}

IndividualSection.propTypes = {
  fields: PropTypes.object.isRequired,
  lensR: PropTypes.object,
  lensL: PropTypes.object,
  t: PropTypes.func.isRequired,
}

const enhance = compose(
  connect(
    ({ catalog }) => ({
      lensR: catalog.currentLensR,
      lensL: catalog.currentLensL,
    }),
    {},
  ),
  withTranslation(),
)

export default enhance(IndividualSection)
